import React, { memo } from 'react';
import arePropsEqual from 'react-fast-compare';
import NavigationList from '../components/NavigationList';
import type { SidebarNavigation } from '../types';

type MainNavigationProps = {
  isLoading: SidebarNavigation['isLoading'];
  items: SidebarNavigation['main'];
  sectionIndex: number;
};

const MainNavigation = ({
  isLoading,
  items,
  sectionIndex,
}: MainNavigationProps) => {
  return (
    <NavigationList
      items={items}
      isLoading={isLoading}
      sectionIndex={sectionIndex}
      withoutDivider
    />
  );
};

export default memo(MainNavigation, arePropsEqual);
